module.exports = __webpack_public_path__ + "img/seminar8.35667bca.jpg";